import { IUserDetail } from "../models/IUserDetail";
import { configWithUserToken } from "./config";

export interface IUpdateMyProfile {
  /** Değişmeyen alanlar gönderilmez; backend boş alanı "dokunma" olarak okur. */
  customerEmail?: string;
  customerTelNo?: string;
  customerBirthDate?: string;
}

export interface IChangePassword {
  /** Hesabın giriş e-postası (backend mevcut şifreyi bununla doğrular) */
  email: string;
  oldPassword: string;
  newPassword: string;
}

export const getMyProfile = () =>
  configWithUserToken.get<IUserDetail>("Auth/CustomerDetailsByToken");

export const updateMyProfile = (userId: string, payload: IUpdateMyProfile) =>
  configWithUserToken.put(`Auth/UpdateUserProfile/${userId}`, payload);

export const changeMyPassword = (payload: IChangePassword) =>
  configWithUserToken.put("Auth/ChangePassword", payload);
